import React from "react";

const localDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};
const parseLocal = (value) => new Date(`${value}T12:00:00`);
const daysFor = (view, startDate) => {
  if (view === "today") return 1;
  if (view === "week") return 7;

  if (view === "month") {
    const date = parseLocal(startDate);
    return new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).getDate();
  }

  return 7;
};

export default function OccupancyToolbar({
  view,
  setView,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onCreateStay,
  search,
  setSearch,
  hostelList = [],
  selectedHostel,
  setSelectedHostel,
}) {
  React.useEffect(() => {
    if (!startDate || !setEndDate) return;
    const end = parseLocal(startDate);
    end.setDate(end.getDate() + daysFor(view, startDate) - 1);
    const nextEnd = localDate(end);
    if (nextEnd !== endDate) setEndDate(nextEnd);
  }, [startDate, view, endDate, setEndDate]);

 const move = (direction) => {
  if (!startDate) return;

  const date = parseLocal(startDate);

  if (view === "month") {
    date.setDate(1);
    date.setMonth(date.getMonth() + direction);
  } else {
    date.setDate(
      date.getDate() + direction * (view === "today" ? 1 : 7)
    );
  }

  setStartDate(localDate(date));
};

  const selectView = (nextView) => {
  const date = parseLocal(startDate || localDate(new Date()));

  if (nextView === "today") {
    setStartDate(localDate(new Date()));
  } else if (nextView === "month") {
    // Month view always starts on the first day of the month.
    date.setDate(1);
    setStartDate(localDate(date));
  } else if (nextView === "week") {
    // Preserve the current selected date when switching to week view.
    setStartDate(localDate(date));
  }

  setView(nextView);
};

  const monthLabel = startDate
    ? parseLocal(startDate).toLocaleDateString(undefined, { month: "long", year: "numeric" })
    : "";

  return (
    <div className="occ-toolbar">
      <div className="occ-toolbar-left">
        <div className="occ-date-navigation">
          <button type="button" aria-label="Previous date range" onClick={() => move(-1)}>‹</button>
          <button type="button" onClick={() => selectView("today")}>Today</button>
          <button type="button" aria-label="Next date range" onClick={() => move(1)}>›</button>
        </div>
        <div className="occ-toolbar-dates">
          <b className="occ-toolbar-month">{monthLabel}</b>
          <span className="occ-date-range">{startDate || "—"} – {endDate || "Calculating…"}</span>
        </div>
      </div>

      <div className="occ-toolbar-right">
        <select
          className="occ-hostel-select"
          value={selectedHostel ?? ""}
          onChange={(e) => setSelectedHostel(e.target.value)}
          aria-label="Select hostel"
        >
          <option value="">Select Hostel</option>
          {hostelList.map((hostel) => (
            <option key={hostel.id} value={hostel.id}>{hostel.hostelName}</option>
          ))}
        </select>

        <input
          className="occ-search"
          placeholder="Search room or tenant…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          aria-label="Search room or tenant"
        />

        <div className="occ-view-switch" role="group" aria-label="Timeline view">
          {[
            ["today", "Today"],
            ["week", "Week"],
            ["month", "Month"],
          ].map(([value, label]) => (
            <button
              key={value}
              type="button"
              className={view === value ? "active" : ""}
              aria-pressed={view === value}
              onClick={() => selectView(value)}
            >
              {label}
            </button>
          ))}
        </div>

        <button type="button" className="occ-primary-btn" onClick={onCreateStay}>
          ＋ New stay
        </button>
      </div>
    </div>
  );
}
